export enum MovementType {
  ACCRUED_PAYMENT = "accrued_payment",
  AMORTIZATION = "amortization",
  ACCRUED_INTEREST = "accrued_interest",
  ASSET_LIQUIDATION = "asset_liquidation",
  CALL_SUBSEQUENT_CLOSING = "call_subsequent_closing",

  CAPITAL_CALL = "capital_call",
  CAPITAL_GAIN = "capital_gain",
  CASH = "cash",
  DISTRIBUTION = "distribution",
  DISTRIBUTION_SUBSEQUENT_CLOSING = "distribution_subsequent_closing",

  DIVIDEND = "dividend",

  FEEDER_FEE = "feeder_fee",
  FEES = "fees",
  HOME_LOAN = "home_loan",
  INTEREST = "interest",
  OTHER_LOAN = "other_loan",
  RETURN_EXCESS_CALL = "return_excess_call",
  RETURN_EXCESS_DISTRIBUTION = "return_excess_distribution",
  RETURN_EXCESS_TEMPORARY_DISTRIBUTION = "return_excess_temporary_distribution",
  TRANSFER_FUND_REALLOCATION = "transfer_fund_reallocation",
  TEMPORARY_RETURN_CAPITAL = "temporary_return_capital",
}
